import React from 'react';
import { IColumn } from '../columns';
import { ITransactions } from '../TransactionHistory.model';

import styles from './TransactionHistoryMobileCard.module.css';

interface Props {
  data: ITransactions[];
  columns: IColumn[];
  emptyMessage: string;
}

const TransactionCard = ({ data, emptyMessage, columns }: Props) => {
  const getContent = (cardData) => (
    <>
      {columns.map((col) => (
        <div key={col.Header} className={styles.cellWrapper}>
          <span className={styles.cellLabel}>{col.Header}</span>
          <span className={styles.cellValue}>{cardData[col.accessor]}</span>
        </div>
      ))}
    </>
  );

  if (!data.length) {
    return <div className={styles.emptyMessage}>{emptyMessage}</div>;
  }

  return (
    <>
      {data.map((card) => (
        <div key={card.id} className={styles.cardWrapper}>
          <div className={styles.colorInfoWrapper}>
            <div className={styles.colorInfo} style={{ background: card.type === 'Debit' ? '#EE312A' : '#27AE60' }} />
          </div>
          {getContent(card)}
        </div>
      ))}
    </>
  );
};

export default TransactionCard;
